import React, { useState } from 'react';
import './App.css';
import { Router, Redirect, navigate } from "@reach/router";
import LoginPage from './pages/login-page'
import PrivateRoute from './components/private-route'
import { AuthContext, AuthProvider } from './helpers/auth-context'
import NotFound from './pages/not-found'
import HelloWorld from './pages/hello-world'
import TermsPage from './pages/terms-page'
import PrivacyPage from './pages/privacy-page'
import LandingPage from './pages/landing-page'
import TrustedNetworkLandingPage from './pages/trusted-network-landing-page'
import VentureDebtLandingPage from './pages/venture-debt-landing-page'
import Dashboard from './pages/dashboard'
import EVFleetLandingPage from './pages/ev-fleet-landing-page'

function App() {
  const [user, setUser] = useState(null);

  const updateUser = newUser => {
    setUser(newUser);
  }

  return (
    <AuthProvider
      value={{
        user,
        updateUser
      }}
    >
      <Router style={{ height: '100%' }}>
        { /* <LandingPage path="/" /> */ }
        <VentureDebtLandingPage path="/" />
        <TrustedNetworkLandingPage path="/searchads" />
        <EVFleetLandingPage path="/fleet" />
        <VentureDebtLandingPage path="/debt" />
        <TrustedNetworkLandingPage path="/connect" />
        <TermsPage path="/terms" />
        <PrivacyPage path="/privacy" />
        <HelloWorld path="/nothingishere" />
        <HelloWorld path="/dontclick" />
        <LandingPage path="/l/:app" />
        <LandingPage path="/landing/:app" />
        <LandingPage path="/signup/:app" />
        <PrivateRoute as={Dashboard} path="/dashboard" />
        <PrivateRoute as={Dashboard} path="/dashboard/:page" />
        <NotFound default />
      </Router>
    </AuthProvider>
  );
}

export default App;
